import DailySearchQuotaMeter from './DailySearchQuotaMeter.vue';

export default DailySearchQuotaMeter;
